<template>
  <div>
    <div class="px-12 pt-12">
      <div>
        <nav class="relative z-0 rounded-lg shadow flex divide-x divide-gray-200">
          <RouterLink
            v-for="(tab, idx) in tabs"
            :key="idx"
            :to="tab.route"
            custom
            v-slot="{ href, navigate, isActive }"
          >
            <a
              :href="href"
              class="text-gray-900 first:rounded-l-lg last:rounded-r-lg group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
              :class="[isActive ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700']"
              @click="navigate"
            >
              <span>{{ tab.label }}</span>
              <span
                aria-hidden="true"
                class="absolute inset-x-0 bottom-0 h-0.5"
                :class="[isActive ? 'bg-indigo-500' : 'bg-transparent']"
              />
            </a>
          </RouterLink>
        </nav>
      </div>
    </div>
    <RouterView />
  </div>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tabs: [
        {
          label: 'Facebook pages',
          route: {
            name: 'accounts.accountId.prospects.facebook',
            params: {
              accountId: this.accountId,
            },
          },
        },
        {
          label: 'Instagram',
          route: {
            name: 'accounts.accountId.prospects.instagram',
            params: {
              accountId: this.accountId,
            },
          },
        },
      ],
    };
  },
};
</script>
